import type { User } from './types';

export const SUPER_ADMIN_ROLE_NAME = 'Super Admin';

export function isSuperAdminUser(user: Pick<User, 'roles'>): boolean {
  return user.roles.some((r) => r.name === SUPER_ADMIN_ROLE_NAME);
}
